// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import {
  ADD_ANTENNA_SETTINGS,
  ADD_FREQUENCY_SETTINGS,
  ADD_REGULATORY_SETTINGS,
  ADD_RADIO_SETTINGS,
} from './types'

export const addAntennaSettings = settings => ({
  type: ADD_ANTENNA_SETTINGS,
  ...settings,
})

export const addFrequencySettings = settings => ({
  type: ADD_FREQUENCY_SETTINGS,
  settings,
})

export const addRegulatorySettings = settings => ({
  type: ADD_REGULATORY_SETTINGS,
  settings,
})

export const addRadioSettings = settings => ({
  type: ADD_RADIO_SETTINGS,
  settings,
})
